module.exports = __webpack_public_path__ + "static/Rat.2dfd0ad8.png";